import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "donations-table table-responsive-md mt-2 mb-3" }
const _hoisted_2 = { class: "table table-borderless" }
const _hoisted_3 = { class: "table-primary" }
const _hoisted_4 = { class: "align-middle" }
const _hoisted_5 = { class: "d-flex justify-content-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "fw-bold m-0" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = ["fill"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", { d: "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["fill"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", { d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
            return (_openBlock(), _createElementBlock("th", {
              key: index,
              class: "sorting-column py-2",
              scope: "col"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn w-100 d-flex flex-row align-items-center justify-content-center gap-3",
                  onClick: ($event: any) => (_ctx.setFilterBy(header.key)),
                  ref_for: true,
                  ref: `sortBy${
                  header.key.charAt(0).toUpperCase() + header.key.slice(1)
                }`
                }, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(header.label), 1),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(), _createElementBlock("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "14",
                      height: "14",
                      fill: 
                      _ctx.filterBy === header.key && _ctx.ascending
                        ? '#000000'
                        : '#adb5bd'
                    ,
                      class: "bi bi-caret-up-fill",
                      viewBox: "0 0 16 16"
                    }, _hoisted_11, 8, _hoisted_9)),
                    (_openBlock(), _createElementBlock("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "14",
                      height: "14",
                      fill: 
                      _ctx.filterBy === header.key && !_ctx.ascending
                        ? '#000000'
                        : '#adb5bd'
                    ,
                      class: "bi bi-caret-down-fill",
                      viewBox: "0 0 16 16"
                    }, _hoisted_14, 8, _hoisted_12))
                  ])
                ], 8, _hoisted_6)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDonations, (donation) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: donation.itemId,
            class: "donation align-middle"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (header.key !== 'quantity' && header.key !== 'weight')
                  ? (_openBlock(), _createElementBlock("td", {
                      key: index,
                      class: "text-center py-2"
                    }, _toDisplayString(donation[header.key]), 1))
                  : (header.key === 'quantity')
                    ? (_openBlock(), _createElementBlock("td", {
                        key: index,
                        class: "text-center py-2"
                      }, _toDisplayString(`${donation[header.key]} ${
                    donation[header.key] > 1 ? "pieces" : "piece"
                  }`), 1))
                    : (header.key === 'weight')
                      ? (_openBlock(), _createElementBlock("td", {
                          key: index,
                          class: "text-center py-2"
                        }, _toDisplayString(`${donation[header.key]} ${
                    donation[header.key] !== 1 ? "kilos" : "kilo"
                  }`), 1))
                      : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ]))
        }), 128))
      ])
    ])
  ]))
}